import { ref } from "vue";
import { permissions } from "@/domain/labels.js";
import { permissionAllowed } from "@/domain/access.js";
function readProfile() {
  try {
    return JSON.parse(localStorage.getItem("admin_profile") || "null");
  } catch {
    return null;
  }
}
export const profile = ref(readProfile());
export const authenticated = ref(Boolean(localStorage.getItem("admin_token")));
export function saveSession(admin) {
  localStorage.setItem("admin_token", admin.token);
  localStorage.setItem("admin_profile", JSON.stringify(admin));
  profile.value = admin;
  authenticated.value = true;
}
export function logout() {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_profile");
  profile.value = null;
  authenticated.value = false;
}
export function canAccess(key) {
  if (!authenticated.value) return false;
  return permissionAllowed(profile.value, key);
}
export function firstAllowedPage() {
  return permissions.find((item) => canAccess(item.key))?.key || "no-access";
}
window.addEventListener("admin-session-expired", logout);
window.addEventListener("storage", (event) => {
  if (["admin_token", "admin_profile"].includes(event.key)) {
    profile.value = readProfile();
    authenticated.value = Boolean(localStorage.getItem("admin_token"));
  }
});
